import { render, staticRenderFns } from "./batchHintDialog.vue?vue&type=template&id=2b53c09c&scoped=true"
import script from "./batchHintDialog.vue?vue&type=script&lang=js"
export * from "./batchHintDialog.vue?vue&type=script&lang=js"
import style0 from "./batchHintDialog.vue?vue&type=style&index=0&id=2b53c09c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53c09c",
  null
  
)

export default component.exports